// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__t5OBT","title":"styles_title__2gQ-A","subtitle":"styles_subtitle__3YJsP"};